import script from "./LoginPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPhone.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPhone.vue?vue&type=style&index=0&id=08249f7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08249f7d"]])

export default __exports__